import { render, staticRenderFns } from "./ProductExtraView.vue?vue&type=template&id=2b2e2086"
import script from "./ProductExtraView.vue?vue&type=script&lang=js"
export * from "./ProductExtraView.vue?vue&type=script&lang=js"
import style0 from "./ProductExtraView.vue?vue&type=style&index=0&id=2b2e2086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports